import axios from "axios";
import handleError from "../../../utils/handleError";
import Client from "client-sdk/src/client";
import {GetVehicleByPlateRequestBuilder} from "client-sdk/src/entrances/getVehicleByPlate"

// export default const getDrivers = () => {

// }

const token = localStorage.getItem("token");

export async function getVehicleByPlateNum(plateNum: any) {
  try {
    const vehicleByPlate = new GetVehicleByPlateRequestBuilder()
    .params({"plateNumber.contains": plateNum})
    .build();
    const client = new Client(token as string);
    const response = client.execute(
      vehicleByPlate,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}

export default getVehicleByPlateNum;
